import { datatableInit } from "../functions/datatableInit";
import Swal from "sweetalert2";

const loader = window.customLoader

const scaleList = () => {

    $(document).on('click', '.remove-scale', function () {
        const id = $(this).data('id')

        Swal.fire({
            icon: 'question',
            title: 'Czy na pewno chcesz usunąć skalę?',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: true,
            confirmButtonText: 'Tak, usuń',
            confirmButtonColor: '#dc3545',
            showCancelButton: true,
            cancelButtonText: 'Nie, anuluj',
            cancelButtonColor: '#6c757d'
        }).then(result => {
            console.log(result)
            if (result.isConfirmed)
            {
                $.ajax({
                    "beforeSend": function (){
                        loader.show()
                    },
                    type: 'post',
                    url: Routing.generate('surveys_scale_remove', {id: id}),
                    "complete": function (){
                        loader.hide()
                    }
                }).done(d => {
                    if (!d.error)
                    {
                        Swal.fire({
                            icon: 'success',
                            title: 'Skala została usunięta',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirmButtonText: 'Zamknij',
                            confirmButtonColor: '#3f51b5',
                        }).then( () => {
                            location.reload();
                        })
                    }
                    else
                    {
                        Swal.fire({
                            icon: 'error',
                            title: 'Nie udało się usunąć skali',
                            text: d.error,
                            confirmButtonText: 'Zamknij',
                            confirmButtonColor: '#3f51b5',
                        })
                    }
                })
            }
            else
            {
                Swal.fire({
                    icon: 'warning',
                    title: 'Anulowano usuwanie skali',
                    confirmButtonText: 'Zamknij',
                    confirmButtonColor: '#3f51b5',
                })
            }
        })
    })

    $(() => {

        datatableInit('.datatable')

    })

}

window.initScaleList = () => {
    scaleList()
}